import { IConstructorResultData } from 'shared/types/ConstructorResult';

/**
 * [buildPtLinkUrl]
 * Takes in a result from constructor (PT)
 * and links to the proper pdp link based
 * on the category and product type
 */
export const buildPtLinkUrl = (result: IConstructorResultData) => {
  const { category, product_type: productType, slug, productCategory } = result || {};

  if (category === 'shoes' || productType === 'sneakers' || productCategory === 'SHOES') {
    return `/sneakers/${slug}`;
  }

  return `/apparel/${slug}`;
};
